import { gql } from '@provision/graphql-client';

export type CustomSignupLinkIntervalUnit = 'month' | 'year';

export interface GenerateCustomSignupLinkMutationResponse {
  generateCustomMembershipCheckoutUrl: {
    url: string;
  };
}

export interface GenerateCustomSignupLinkMutationVariables {
  input: {
    addressId: string;
    partnerId: number;
    partnerProductId: string;
    amountCents: number;
    intervalUnit: CustomSignupLinkIntervalUnit;
    intervalCount: number;
    cancelUrl?: string;
    successUrl?: string;
    disableLink?: boolean;
  };
}

export const GENERATE_CUSTOM_SIGNUP_LINK_MUTATION = gql`
  mutation GenerateCustomSignupLink($input: GenerateCustomMembershipCheckoutUrlInput!) {
    generateCustomMembershipCheckoutUrl(input: $input) {
      url
    }
  }
`;
